import { Length, LengthPercentage, Token, Tuple } from "@siteimprove/alfa-css";
import { Parser } from "@siteimprove/alfa-parser";
import { Longhand } from "../longhand.js";
import { Resolver } from "../resolver.js";
const { takeBetween, map, delimited, option } = Parser;
const parse = map(takeBetween(delimited(option(Token.parseWhitespace), LengthPercentage.parse), 1, 2), ([horizontal, vertical = horizontal]) => Tuple.of(horizontal, vertical));
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/border-top-left-radius}
 * @internal
 */
export default Longhand.of(Tuple.of(Length.of(0, "px"), Length.of(0, "px")), parse, (value, style) => value.map(({ values: [h, v] }) => Tuple.of(LengthPercentage.partiallyResolve(Resolver.length(style))(h), LengthPercentage.partiallyResolve(Resolver.length(style))(v))));
//# sourceMappingURL=border-top-left-radius.js.map